/**
 * FieldPairComponent - A reusable component for displaying field label and value pairs
 * Used to standardize the layout of field displays across view components
 */

const FieldPairComponent = ({ label, children }) => {
  return (
    <div className="additional-fields-container">
      <div className="field-pair">
        <strong className="field-label">{label}:</strong>
      </div>
      <div className="field-pair-two-column">{children}</div>
    </div>
  );
};

export default FieldPairComponent;
